<template>
    <div class="bloco margem" style="display: flex; flex-flow: column">
        <div class="m-b">
            <a class="direita" style="width: 10rem;" :class="colapsado ? 'ativo' : ''"
                onclick="this.classList.toggle('ativo');return false" @click="colapsado = !colapsado"><span
                    class="direita toggle"></span>Visão Compacta</a>
        </div>
        <div class="grid-3" style="min-height: 27vw;">
            <div class="colunaKanban" style="border-color: rgb(255, 145, 0)">
                <h3>A iniciar</h3>
                <draggable v-model="pendentes" group="kanban" item-key="codigo" class="containerTarefa"
                    @change="(event) => atualizarStatus(event, 'Pendente')">
                    <template #item="{ element }">
                        <div class="tarefa" :class="{ colapsada: colapsado }">
                            <template v-if="!colapsado">
                                <label class="tituloTarefa">{{ element.codigo }}</label>
                                <span>{{ element.comentario }}</span>
                                <div class="rodapeTarefa">
                                    <div>
                                        <label>Responsável</label>
                                        <span>{{ element.usuario ?? '-' }}</span>
                                    </div>
                                    <div>
                                        <label>HP</label>
                                        <span>{{ element.HP ?? '0' }}</span>
                                    </div>
                                    <div>
                                        <label>Término</label>
                                        <span>{{ element.dtFim ? formatDate(element.dtFim) : '-' }}</span>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <label class="tituloTarefa tituloColapsado">{{ element.codigo }}</label>
                                <p class="comentarioColapsado" :title="element.comentario">{{ element.comentario }}</p>
                                <div class="colapsadoInfos">
                                    <small><strong>Responsável:</strong> {{ nomeEsobrenome(element.usuario) ?? '-'
                                        }}</small>
                                    <small><strong>Término:</strong> {{ element.dtFim ? formatDate(element.dtFim) : '-'
                                    }}</small>
                                </div>
                            </template>
                        </div>
                    </template>
                </draggable>
            </div>
            <div class="colunaKanban" style="border-color: rgb(0, 47, 255)">
                <h3>Em andamento</h3>
                <draggable v-model="emAndamento" group="kanban" item-key="codigo" class="containerTarefa"
                    @change="(event) => atualizarStatus(event, 'Em andamento')">
                    <template #item="{ element }">
                        <div class="tarefa" :class="{ colapsada: colapsado }">
                            <template v-if="!colapsado">
                                <label class="tituloTarefa">{{ element.codigo }}</label>
                                <span>{{ element.comentario }}</span>
                                <div class="rodapeTarefa">
                                    <div>
                                        <label>Responsável</label>
                                        <span>{{ element.usuario ?? '-' }}</span>
                                    </div>
                                    <div>
                                        <label>HP</label>
                                        <span>{{ element.HP ?? '0' }}</span>
                                    </div>
                                    <div>
                                        <label>Término</label>
                                        <span>{{ element.dtFim ? formatDate(element.dtFim) : '-' }}</span>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <label class="tituloTarefa tituloColapsado">{{ element.codigo }}</label>
                                <p class="comentarioColapsado" :title="element.comentario">{{ element.comentario }}</p>
                                <div class="colapsadoInfos">
                                    <small><strong>Responsável:</strong> {{ element.usuario ?
                                        nomeEsobrenome(element.usuario) : '-' }}</small>
                                    <small><strong>Término:</strong> {{ element.dtFim ? formatDate(element.dtFim) : '-'
                                    }}</small>
                                </div>
                            </template>
                        </div>
                    </template>
                </draggable>
            </div>
            <div class="colunaKanban" style="border-color: rgb(0, 192, 0)">
                <h3>Concluído</h3>
                <draggable v-model="concluidas" group="kanban" item-key="codigo" class="containerTarefa"
                    @change="(event) => atualizarStatus(event, 'Concluído')">
                    <template #item="{ element }">
                        <div class="tarefa" :class="{ colapsada: colapsado }">
                            <template v-if="!colapsado">
                                <label class="tituloTarefa">{{ element.codigo }}</label>
                                <span>{{ element.comentario }}</span>
                                <div class="rodapeTarefa">
                                    <div>
                                        <label>Responsável</label>
                                        <span>{{ element.usuario ?? '-' }}</span>
                                    </div>
                                    <div>
                                        <label>HP</label>
                                        <span>{{ element.HP ?? '0' }}</span>
                                    </div>
                                    <div>
                                        <label>Término</label>
                                        <span>{{ element.dtFim ? formatDate(element.dtFim) : '-' }}</span>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <label class="tituloTarefa tituloColapsado">{{ element.codigo }}</label>
                                <p class="comentarioColapsado" :title="element.comentario">{{ element.comentario }}</p>
                                <div class="colapsadoInfos">
                                    <small><strong>Responsável:</strong> {{ nomeEsobrenome(element.usuario) ?? '-'
                                        }}</small>
                                    <small><strong>Término:</strong> {{ element.dtFim ? formatDate(element.dtFim) : '-'
                                    }}</small>
                                </div>
                            </template>
                        </div>
                    </template>
                </draggable>
            </div>
        </div>
    </div>
</template>
<script>
import draggable from "vuedraggable";
import serviceFunções from '@/services/serviceFunções';

export default {
    components: {
        draggable
    },
    props: {
        tarefas: {
            required: true
        }
    },
    data() {
        return {
            pendentes: [],
            emAndamento: [],
            concluidas: [],
            colapsado: false
        };
    },
    methods: {
        atualizarStatus(event, status) {
            if (event.added) {
                this.$emit("atualizarTarefa", event.added.element.id, "status", status);
            }
        },
        formatDate(date) {
            if (date != "-") {
                const dia = date.split("-")[2];
                const mes = date.split("-")[1];
                const ano = date.split("-")[0];
                return `${dia}/${mes}/${ano}`;
            } else {
                return date;
            }
        },
        nomeEsobrenome(nome) {
            if (!nome || typeof nome !== 'string') return '-';
            return serviceFunções.nomeEsobrenome(nome);
        }

    },
    mounted() {
        this.pendentes = this.tarefas.filter(tarefa => tarefa.status.includes("Pendente")).sort((a, b) => {
            if (!a.dtFim) return 1;
            if (!b.dtFim) return -1;
            return new Date(a.dtFim) - new Date(b.dtFim);
        });
        this.emAndamento = this.tarefas.filter(tarefa =>
            ["Em andamento", "Em andamento 25%", "Em andamento 50%", "Em andamento 75%"].some(status => tarefa.status.includes(status))
        ).sort((a, b) => {
            if (!a.dtFim) return 1;
            if (!b.dtFim) return -1;
            return new Date(a.dtFim) - new Date(b.dtFim);
        });
        this.concluidas = this.tarefas.filter(tarefa => tarefa.status.includes("Concluído")).sort((a, b) => {
            if (!a.dtFim) return 1;
            if (!b.dtFim) return -1;
            return new Date(a.dtFim) - new Date(b.dtFim);
        });
    }
};
</script>
<style scoped>
.colapsadoInfos {
    display: flex;
    justify-content: space-between;
    margin-top: 4px;
    font-size: 1rem;
    color: #666;
}

.containerTarefa {
    min-height: 100%;
    min-width: 10rem;
    width: 95%;
}

.colunaKanban {
    text-align: center;
    border: 1px solid var(--cor-separador);
    border-radius: 12px;
    padding-top: .5rem;
    justify-items: center;
}

.tituloTarefa {
    font-size: 16px;
    font-weight: bold;
}

.tarefa {
    border: 1px solid var(--cor-separador);
    padding: 0.5rem;
    border-radius: 12px;
    margin-bottom: 0.5rem;
    background-color: #fff;
    max-height: 200px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.tarefa:not(.colapsada) span {
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.tarefa.colapsada {
    display: inline-block;
    width: calc(50% - 0.5rem);
    vertical-align: top;
    margin: 0.25rem;
    padding: 0.25rem;
    font-size: 0.75rem;
    max-width: 24rem;
}

.tarefa.colapsada p.comentarioColapsado {
    margin: 0;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.tarefa.colapsada .terminoColapsado {
    display: block;
    margin-top: 0.25rem;
    text-align: right;
    font-size: 0.7rem;
    color: #666;
}

.rodapeTarefa {
    display: flex;
    gap: 5px;
}

.rodapeTarefa label {
    font-weight: bold;
    margin: 0 !important;
}

.rodapeTarefa div {
    display: flex;
    flex-flow: column;
    flex-grow: 1;
    border: 1px solid var(--cor-separador);
    border-radius: 12px;
    padding: 2px 6px;
}
</style>